<div class="tabs" *ngIf="tabsState() as tabsInfo">
  <ul
    class="nav scrollable-content scrollable-content--hover tabs__nav"
    #divToScroll
  >
    <li
      class="nav-item tabs__nav__item"
      *ngFor="let tab of tabsInfo.tabs; index as i"
    >
      <button
        class="btn btn-link nav-link tabs__nav__item__btn"
        [ngClass]="{ active: tabsInfo.selectedTab === i }"
        type="button"
        (click)="onTabSwitch(i)"
      >
        <div
          (blur)="onTabRename($event, i)"
          (keydown.enter)="$any($event.target).blur()"
          [contentEditable]="i === tabsInfo.selectedTab ? true : false"
        >
          {{ tab.name }}
        </div>
      </button>
      <div
        *ngIf="tabsInfo.tabs.length > 1"
        class="tabs__nav__item__close-tab-container"
      >
        <cds-icon
          shape="window-close"
          (click)="onCloseTab(i)"
          class="close-icon"
        ></cds-icon>
      </div>
    </li>
  </ul>

  <div class="tabs__add-tab-container">
    <cds-icon
      shape="plus"
      class="is-solid add-button"
      (click)="addNewTab()"
    ></cds-icon>
  </div>
</div>

<app-warning-screen
  [isModalOpened]="warningScreenData.warningScreenOpen"
  [headerMessage]="warningScreenData.headerMessage"
  [messageToDisplay]="warningScreenData.messageToDisplay"
  [yesNoOptions]="true"
  (communicate)="shouldTabBeClosed($event)"
  (warningOpenChanged)="shouldTabBeClosed(false)"
></app-warning-screen>
